import { render, staticRenderFns } from "./login-multi.html?vue&type=template&id=01832d04&"
import script from "./LoginMulti.vue?vue&type=script&lang=js&"
export * from "./LoginMulti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports